import GoogleRedirect from '@/pages/auth/login/google/redirect'
import Login from '../pages/auth/login'
import { Navigate, Route, Routes } from 'react-router-dom'
import GoogleSignupRedirectPage from '@/pages/auth/signup/google/redirect'
import SignupPage from '@/pages/auth/signup'
import ChannelManagePage from '@/pages/channels/verify'
import ChannelVerifyPage from '@/pages/channels/verify/select-method'
import EmailVerifyPage from '@/pages/channels/verify/email'
import ChannelPage from '@/pages/manage/[email]/channel'
import VideosPage from '@/pages/manage/[email]/videos'
import ChannelVerifyRedirectPage from '@/pages/channels/verify/redirect'
import VideoDetailPage from '@/pages/manage/videos/[id]'
import MyPage from '@/pages/my-page'
import pagePath from '@/utils/pagePath'
import AccessControlRoute from './AccessControlRout'
import { initLoggingEnvironment } from '@/libs/log'

const Router = () => {
  initLoggingEnvironment()
  return (
    <Routes>
      <Route path={'/'} element={<Navigate to={pagePath.channelVideos('temp')} replace />} />

      <Route element={<AccessControlRoute accessibleRole="UNAUTHORIZED" />}>
        <Route path={'/auth/login'} element={<Login />} />
        <Route path={'/auth/login/google/redirect'} element={<GoogleRedirect />} />
        <Route path={'/auth/signup'} element={<SignupPage />} />
        <Route path={'/auth/signup/google/redirect'} element={<GoogleSignupRedirectPage />} />
      </Route>

      <Route element={<AccessControlRoute accessibleRole="AUTHORIZED" />}>
        <Route path={'/manage/:email/channel'} element={<ChannelPage />} />
        <Route path={'/manage/:email/videos'} element={<VideosPage />} />
        <Route path={'/manage/videos/:videoId'} element={<VideoDetailPage />} />

        <Route path={'/channels/verify'} element={<ChannelManagePage />} />
        <Route path={'/channels/verify/select-method'} element={<ChannelVerifyPage />} />
        <Route path={'/channels/verify/email'} element={<EmailVerifyPage />} />
        <Route path={'/channels/verify/redirect'} element={<ChannelVerifyRedirectPage />} />

        <Route path={'/my-page'} element={<MyPage />} />
      </Route>
      <Route path="*" element={<Navigate to={pagePath.channelVideos('temp')} replace />} />
    </Routes>
  )
}

export default Router
